import React from 'react'
import { Oval } from "react-loader-spinner";

const Loader = () => {
    return (
        <>
            <Oval
                height={60}
                width={60}
                color="#00365a"
                wrapperStyle={{ justifyContent: "center",paddingTop: "100px" }}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#00365a"
                strokeWidth={2}
                strokeWidthSecondary={2}
            />
        </>
    )
}

export default Loader